import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import { ScriptFileType } from "./ScriptFileTable";
import api from "../../../../../API";
// import SampleRejectRsnDialog from "./SampleRejectRsnDialog";
import PhotoIcon from '@mui/icons-material/Photo';
import DescriptionIcon from '@mui/icons-material/Description';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ScriptFileRejectRsnDialog from "./ScriptFileRejectRsnDialog"
import { useSelector } from "react-redux";
import { SearchBackDrop } from "../../../../component/common/SearchBackDrop";

interface userDetailProps {
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  rowDetail: ScriptFileType | null;
  setRowDetail: React.Dispatch<React.SetStateAction<ScriptFileType>>;
  getScriptFileList: any;
  scriptState:any;
  p_uploadDate:any;
  p_worker:any;
  p_order:any;
}

const initailData: ScriptFileType = {
  idx: -1,
  mgm_con_pk: "",
  did: "",
  content_type: "",
  email: "",
  name: "",
  origin_file_name: "",
  file_dir: "",
  file_type: "",
  extension: "",
  state: "",
  ins_date: "",
  reject_rsn : "",
  upload_date: "",
  ki_doc:null,
  // sttsrt:[]
};

interface ScriptFileSttSrtType{
  seq: number;
  mgm_con_pk: string;
  stc_con: string;
  con_type: string;
  con_info: string;
  qa_flag: string;
  sid: string;
  did: string;
  gub_ns: string;
  gub_subns: string;
  use_yn: boolean;
}

interface KiDoc{
  did: string;
  did_lpad: string;
  gub_ki: string;
  gub_kinm: string;
  gub_subnm: string;
  ki_stc: KiStc[];
  title: string;
  url: string;
  use_yn: string;
}

interface KiStc{
  did: string;
  keyword: string;
  sid: string;
  stext: string;
  title_sub: string;
  tkn_num: number;
}

const ScriptDetailDialog = (props: userDetailProps) => {

  const [data, setData] = useState<ScriptFileType>(initailData);

  const [sttsrt, setSttsrt] = useState<ScriptFileSttSrtType[]>([]);

  const [subMenu , setSubMenu] = useState('kistc');

  const [rejectPageOpen , setRejectPageOpen] = useState<boolean>(false);

  const scriptFileRejectPage = () => {
    setRejectPageOpen(true)
  }

  const scriptFileReject = () => {
    props.getScriptFileList(props.scriptState,props.p_order,props.p_uploadDate,props.p_worker)
    setRejectPageOpen(false)
  }

  const handleRemoveRow = (seq:any) => {
    // const updatedSttsrt = sttsrt.filter((row:any) => row.seq !== seq);
    // setSttsrt(updatedSttsrt);
    setSttsrt((prevSttsrt) => {
      const removeIndex = prevSttsrt.findIndex((row) => row.seq === seq);
      const removedSeq = prevSttsrt[removeIndex].seq;
      // console.log('제거 seq :: ',removedSeq)

      // Create a new array excluding the item to be removed
      const updatedSttsrt = prevSttsrt.filter((row) => row.seq !== seq);

      // Adjust the 'seq' of the remaining items if necessary
      const updatedSeqSttsrt = updatedSttsrt.map((row) => {
        if (row.seq > removedSeq) {
          return { ...row, seq: row.seq - 1 };
        }
        return row;
      });

      // console.log('변경된 배열' , updatedSeqSttsrt)

      return updatedSeqSttsrt;
    });
  };

  const handleAddRow = (seq: any) => {
    setSttsrt((prevSttsrt: any) => {
      const addIndex = prevSttsrt.findIndex((row: any) => row.seq === seq);
      const addSeq = prevSttsrt[addIndex].seq + 1;
  
      const randomNumber = Math.random() * 100000; // 0부터 100000 사이의 랜덤 숫자 생성
      const roundedNumber = Math.round(randomNumber) / 100000; // 소수점 다섯 자리까지 반올림

      console.log('roundedNumber', roundedNumber)

      const newItem = {
        ...prevSttsrt[addIndex], // Copy all properties from the original item
        idx: prevSttsrt[addIndex].idx + 0.001 + roundedNumber,
        seq: addSeq,
        qa_flag: "",
        sid: "",
        speaker: "",
        stc_con: "",
      };
  
      // Create a new array with the new item inserted at the specified index
      const addedSttsrt = [
        ...prevSttsrt.slice(0, addIndex + 1),
        newItem,
        ...prevSttsrt.slice(addIndex + 1),
      ];
  
      // Adjust the 'seq' of the remaining items after the insert index
      const updatedSeqSttsrt = addedSttsrt.map((row: any, index: number) => ({
        ...row,
        seq: index + 1,
      }));
  
      console.log('변경된 배열', updatedSeqSttsrt);
      return updatedSeqSttsrt;
    });
  };

  const handleChangeQA = (qa:string,seq: any) => {

    console.log('체크' ,qa ,seq , (qa === 'Q') ,seq%2 , ((seq%2) != 0) )
    if((qa === 'A') && ((seq%2) != 0)){
      alert('참석자 1 은 답변을 설정할 수 없습니다.')
      return;
    }

    if((qa === 'Q') && ((seq%2) == 0)){
      alert('참석자 2 는 질문을 설정할 수 없습니다.')
      return;
    }

    setSttsrt((prevSttsrt: any) => {
      const updatedSttsrt = [...prevSttsrt];

      const rowIndex = prevSttsrt.findIndex((row: any) => row.seq === seq);

      if(qa === 'Q'){
        updatedSttsrt[rowIndex] = {
          ...updatedSttsrt[rowIndex],
          qa_flag: updatedSttsrt[rowIndex].qa_flag === "Q" ? "" : "Q",
        };
      }else if(qa === 'A'){
        updatedSttsrt[rowIndex] = {
          ...updatedSttsrt[rowIndex],
          sid: updatedSttsrt[rowIndex].qa_flag === "A" ? "" : updatedSttsrt[rowIndex].sid,
          qa_flag: updatedSttsrt[rowIndex].qa_flag === "A" ? "" : "A",
        };
      }
      
      // console.log('변경 ' , updatedSttsrt)

      return updatedSttsrt;
    });
  };

  const handleChangeSID = (p_sid:string,seq: any) => {

    setSttsrt((prevSttsrt: any) => {
      const updatedSttsrt = [...prevSttsrt];

      const rowIndex = prevSttsrt.findIndex((row: any) => row.seq === seq);

      // Modify the qa_flag value for the specific row
      updatedSttsrt[rowIndex] = {
        ...updatedSttsrt[rowIndex],
        sid: p_sid
      };
      
      return updatedSttsrt;
    });
  };

  const handleChangeStc_con = (p_stc_con:string,seq: any) => {

    setSttsrt((prevSttsrt: any) => {
      const updatedSttsrt = [...prevSttsrt];

      const rowIndex = prevSttsrt.findIndex((row: any) => row.seq === seq);

      // Modify the qa_flag value for the specific row
      updatedSttsrt[rowIndex] = {
        ...updatedSttsrt[rowIndex],
        stc_con: p_stc_con
      };
      
      // console.log('변경 sttsrt stc_con' ,seq, updatedSttsrt)

      return updatedSttsrt;
    });
  };

  const [auths, setAuths] = useState([]);
  
  // const [selectedAuth, setSelectedAuth] = useState('');

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;
  

  const getAuths = async () => {
    var result = await api.get("/getAuths");

    setAuths(result.data.data);
    // console.log('result.data.data',result.data.data)
  };

  

  const [kiDoc, setKiDoc] = useState<KiDoc[]>([]);

  const [kiStc, setKiStc] = useState<KiStc[]>([]);

  const getKiDoc = async (did:string) => {
    // console.log('did 다시 인트형으로',parseInt(did, 10),"/getKiDoc?did="+parseInt(did, 10))
    var result = await api.get("/getKiDoc?did="+parseInt(did, 10))
    .then(response => {
      // console.log('getKiDoc 정보', response.data.datas)
      const res = response.data.datas
      if(res.length > 0){
        // console.log('ki_stc 정보 ?? ' , res[0].ki_stc)
        setKiStc(res[0].ki_stc)
      }
      setKiDoc(response.data.datas)
    });


  }

  const getDocumentFileInfo = async (idx:number, file_type:string, file_name:string) => {

    await api.get("/scriptFileDownload?idx="+idx+"&file_type="+file_type,{ responseType: 'blob' })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', file_name);
      document.body.appendChild(link);
      link.click();
    })
    .catch((e:any) => console.log('scriptFileInfo error' , e));
    
  };

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  
  const scriptFileConfirm = async () => {

    if (isButtonDisabled) {
      return; // 이미 버튼이 비활성화된 경우 아무 작업도 하지 않음
    }

    setIsButtonDisabled(true);

    setBackdrop(true);

    const base_data = sttsrt[0]

    const formData = new FormData();

    formData.append("email", email);
    formData.append("mgm_con_pk", data.mgm_con_pk);
    formData.append("gub_ns", base_data.gub_ns);
    formData.append("gub_subns",base_data.gub_subns );
    formData.append("con_info", base_data.con_info);
    formData.append("writer_id", data.email);
    formData.append("writer_name",data.name );

    formData.append("nvConScript", JSON.stringify(sttsrt));

    // console.log("nvConScript",sttsrt)
    // return;
    await api.post("/scriptFileConfirm",formData)
    .then((res:any) => {setIsButtonDisabled(false); setBackdrop(false); alert('스크립트 검토가 완료되었습니다.'); props.getScriptFileList(props.scriptState,props.p_order,props.p_uploadDate,props.p_worker); props.setDialogOpen(false)})
    .catch((error:any) => {setIsButtonDisabled(false); setBackdrop(false); alert(error.response.data.error);})

  }

  const nvConScriptUpdate = async () => {

    const base_data = sttsrt[0]

    const formData = new FormData();

    formData.append("email", email);
    formData.append("mgm_con_pk", data.mgm_con_pk);
    formData.append("gub_ns", base_data.gub_ns);
    formData.append("gub_subns",base_data.gub_subns );
    formData.append("con_info", base_data.con_info);
    formData.append("writer_id", data.email);
    formData.append("writer_name",data.name );

    formData.append("nvConScript", JSON.stringify(sttsrt));

    // console.log('수정 스크립트' , JSON.stringify(sttsrt))

    // return;
    await api.post("/nvConScriptUpdate",formData)
    .then((res:any) => {alert('스크립트검토완료 수정이 완료되었습니다.'); props.getScriptFileList(props.scriptState,props.p_order,props.p_uploadDate,props.p_worker); props.setDialogOpen(false)})
    .catch((error:any) => {alert(error.response.data.error);})

  }

  const getSttsrt = async (mgm_con_pk:string, state:string) => {

    await api.get("/scriptFileSttSrt?mgm_con_pk="+mgm_con_pk+"&state="+(state == '스크립트검토완료' ? '스크립트검토완료' : ''))
    .then((res:any) => {setSttsrt(res.data.datas)})
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  }

  useEffect(() => {
    getAuths();
    // console.log("sampleDetailDialog");
    if (props.rowDetail != null){
      // console.log('스크립트의 DID ?? ' , props.rowDetail.did)
      // getKiStc(props.rowDetail.did)
      getKiDoc(props.rowDetail.did)
      // console.log('정보:???? ???? ' , props.rowDetail)
      setData(props.rowDetail);
      // if(props.rowDetail.state)
      // setSttsrt(props.rowDetail.sttsrt)
      getSttsrt(props.rowDetail.mgm_con_pk, props.rowDetail.state)
      // console.log('sttsrt',props.rowDetail.sttsrt)

    }
  }, [props.rowDetail]);

  const [backdrop, setBackdrop] = useState<boolean>(false)

  

  return (
    <Box>
      <Dialog maxWidth="xl" open={true} fullWidth={true}>
        <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
          <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>스크립트 확인</Box>
          <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
        </DialogTitle>
        <DialogContent dividers>
          {backdrop && ( <SearchBackDrop message={"처리 중..."}/> )}
          <Box display="flex" justifyContent="center">
            <Box sx={{width:"30%"}}>

              <Box>
                {data.idx !== -1 ? 
                <React.Fragment>
                <Box sx={{marginLeft:"2px",marginTop:"16px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>관련자료</Box>
                <Box sx={{width: "90%", border: "3px solid #3e36a5", borderRadius: "3px", margin: "12px", padding: "8px", display:"block" , justifyContent:"center"}}>

                  <Box key={data.idx} display="flex" sx={{marginBottom:"4px", marginLeft:"32px",alignItems: "center"}}>
                    <Box sx={{marginRight:"20px"}}>{data.file_type === "photo" ? <PhotoIcon/> : <DescriptionIcon/>}</Box>
                    <Box sx={{fontWeight:700}}>{data.origin_file_name}</Box>
                    <Box>
                      <Button sx={{backgroundColor:"#ff9800", fontWeight:700, width: "100%", marginLeft: "12px"}} size="small" variant="contained" onClick={()=>{getDocumentFileInfo(data.idx,data.file_type,data.origin_file_name);}}>
                        엑셀 다운
                      </Button>
                    </Box>
                  </Box>
                </Box>
                </React.Fragment>
                :""}
              </Box>

              <Box display="flex">
                <Box sx={{border: "3px solid #000", borderRadius: "5px", padding: "4px", cursor:"pointer",
                  backgroundColor:(subMenu === 'kistc' ? "#000" : "#fff"),
                  color:(subMenu === 'kistc' ? "#fff" : "#000")}}
                  onClick={()=> setSubMenu('kistc')}>지식DB</Box>
                <Box sx={{border: "3px solid #000", borderRadius: "5px", padding: "4px", cursor:"pointer", marginLeft:"8px",
                  backgroundColor:(subMenu === 'worker' ? "#000" : "#fff"),
                  color:(subMenu === 'worker' ? "#fff" : "#000")}}
                  onClick={()=> setSubMenu('worker')}>워커정보</Box>
              </Box>

              {subMenu === 'kistc' && 
                <Box sx={{border: "3px solid #3e36a5", margin: "2px"}}>
                  {kiDoc.length > 0 &&
                    kiDoc.map((doc:KiDoc) =>

                    <Box key={doc.did}>
                      <Box sx={{margin:"16px"}}>문서ID : {doc.did}</Box>
                      <Box sx={{margin:"16px"}}>지식주제분류 : {doc.gub_kinm} {doc.gub_subnm != "" ? <b> 세분류 : + {doc.gub_subnm}</b> : "" }</Box>
                      <Box sx={{margin:"16px"}}>사용여부 : {doc.use_yn}</Box>
                      <Box display="flex" sx={{alignItems:"center", marginLeft:"4px"}}>
                        <Box sx={{fontWeight:600, marginRight:"12px",color:"#fff",backgroundColor:"#498ad5",padding:"4px",borderRadius:"5px"}}>문장ID</Box>
                        <Box sx={{color:"#fff",backgroundColor:"#498ad5",padding:"4px",borderRadius:"5px"}}>문장텍스트</Box>
                      </Box>
                      <Box sx={{margin:"4px"}}>
                      {doc.ki_stc.length > 0 && doc.ki_stc.map((stc:KiStc) =>
                        <Box key={stc.sid} display="flex" sx={{alignItems:"center",border:"2px solid #498ad5"}}>
                          <Box sx={{width:"44px",fontWeight:600,fontSize:"20px", marginRight:"6px", textAlign:"center"}}>{stc.sid}</Box>
                          <textarea defaultValue={stc.stext} style={{width:"370px" , minHeight:"80px", fontSize:"12px", fontWeight:600}} />
                        </Box>
                      )}
                      </Box>

                    </Box>
                    )}
                </Box>
              }
                
              {subMenu === 'worker' && 
                <Box display="flex">
                  <Box sx={{width:"100%", margin:"8px"}}>
                    <Box m={1} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>이메일{data.email}</Box>
                      <TextField
                        id="email"
                        value={data.email}
                        type="email"
                        variant="standard"
                        sx={{width:"230px",marginLeft:"8px", marginRight:"38px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Box>
                    <Box m={1} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>이름</Box>
                      <TextField
                        id="name"
                        value={data.name}
                        variant="standard"
                        sx={{marginLeft:"8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                        onChange={(e: any) =>
                          setData((preData) => ({ ...preData, name: e.target.value }))
                        }
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Box>
                    <Box m={1} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>제출파일명</Box>
                      <TextField
                        id="origin_file_name"
                        value={data.origin_file_name}
                        // label="원본파일명"
                        variant="standard"
                        sx={{marginLeft:"8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                        onChange={(e: any) =>
                          setData((preData) => ({ ...preData, origin_file_name: e.target.value }))
                        }
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Box>
                    <Box m={1} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>업로드시간</Box>
                      <TextField
                        id="ins_date"
                        value={data.ins_date}
                        // label="업로드시간"
                        variant="standard"
                        sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Box>
                    <Box m={1} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>처리상태</Box>
                      <TextField
                        id="state"
                        value={data.state}
                        variant="standard"
                        sx={{marginLeft:"8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              }

            {/* {rejectPageOpen ? <SampleRejectRsnDialog email={data.email} idx={data.idx} getMemberList={props.getMemberList} setRejectPageOpen={setRejectPageOpen} setOpen={setOpen} /> : <></>} */}
            {/* </form> */}
            </Box>
            <Box sx={{width:"70%"}}>
              <Box display="flex">
                <Box sx={{marginLeft:"18px", marginRight:"auto", marginBottom:"12px", fontWeight:700, fontSize: "16px"}}>스크립트 내용 (<b style={{color:"red"}}>-버튼: 줄 삭제</b> <b style={{color:"#2f9c34"}}>+버튼: 아래 줄 추가</b> <b style={{color:"blue"}}>*주의사항</b> : 질문은 참석자 1 , 답변은 참석자 2 )</Box>
                {/* <Box><Button sx={{margin:"auto"}} variant="contained" onClick={()=> setDialogSize(false)}>닫기</Button></Box> */}
                {/* <Box><HighlightOffIcon sx={{cursor:"pointer", marginRight:"16px"}} onClick={()=> {}} /></Box> */}
              </Box>
              <Paper sx={{padding:"4px", border:"3px solid #3e36a5",height:"650px", overflow:"auto"}}>
                {/* <textarea readOnly defaultValue={srt} style={{width:"654px" , height:"654px"}}  /> */}
                {sttsrt.length > 0 ? 
                  (
                    sttsrt.map((row:any,index:any)=>
                    // <Box key={row.idx} sx={{backgroundColor:(row.seq%2 == 0 ? "#dffffc":"#fff"), margin:"4px",borderBottom:"3px solid #3e36a5"}}>
                    <Box key={row.idx} sx={{backgroundColor:(row.seq%2 == 0 ? "#fff":"#fff"), margin:"4px",borderBottom:"3px solid #3e36a5"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box>
                          <Box sx={{display:"flex", alignItems:"center"}}>
                            <Box sx={{width:"24px",fontSize:"24px",fontWeight:700, textAlign: "center", margin: "4px"}}>{row.seq}</Box>
                            <Box sx={{width:"50px", textAlign: "center"}}>
                              {/* <Checkbox sx={{height:"24px"}} checked={true} onClick={(e:any)=> {handleRemoveRow(row.seq)}}></Checkbox> */}
                              <Box sx={{marginBottom:"4px"}}><Button sx={{minWidth:"20px",height:"20px",fontSize:"20px",fontWeight:600,padding:"0 !important",backgroundColor:"#fff",border:"2px solid #ff0000",color:"#ff0000"}} variant="contained" onClick={(e:any)=> {handleRemoveRow(row.seq)}}>-</Button></Box>
                              <Box><Button sx={{minWidth:"20px",height:"20px",fontSize:"20px",fontWeight:600,padding:"0 !important",backgroundColor:"#fff",border:"2px solid #2f9c34",color:"#2f9c34"}} variant="contained" onClick={(e:any)=> {handleAddRow(row.seq)}}>+</Button></Box>
                            </Box>
                            {/* <Checkbox defaultValue="true" onClick={(e:any)=>e.target.checked === true ? setConfirmRole(v.role) : setConfirmRole('')}></Checkbox> */}
                            <Box sx={{width:"90px"}}>
                              {(row.seq%2 != 0) ?
                                <Box sx={{display:"flex", alignItems:"center",height:"24px",margin:"2px"}}>
                                    <Box>질문:</Box>
                                    <Checkbox style={{ color: '#da33f0' }} checked={row.qa_flag == "Q" ? true:false} onClick={(e:any)=> handleChangeQA('Q',row.seq)}></Checkbox>
                                </Box>
                                :
                                <Box>
                                  <Box sx={{display:"flex", alignItems:"center",height:"24px",margin:"2px"}}>
                                    <Box>답변:</Box>
                                    <Checkbox style={{ color: '#27cc2f' }} checked={row.qa_flag == "A" ? true:false} onClick={(e:any)=> handleChangeQA('A',row.seq)}></Checkbox>
                                  </Box>
                                  {/* {row.sid !== "" ? <Box sx={{fontSize:"14px", fontWeight:600, marginLeft:"8px", color:"red"}}>문장ID : {row.sid}</Box>: ""} */}
                                  {row.qa_flag == "A" &&
                                    ((kiStc && kiStc.length !== 0) && 
                                      <Select id="scriptState" value={row.sid} onChange={(e)=>{handleChangeSID(e.target.value, row.seq)}} sx={{width:"80px",height: "30px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px", backgroundColor:"#d5ffd7"}}>
                                        <MenuItem dense value={''}>{''}</MenuItem>
                                        {kiStc.map((stc: any) => 
                                          <MenuItem dense key={stc.sid} value={stc.sid}>{stc.sid}</MenuItem>
                                        )}
                                      </Select>
                                    )
                                  }
                                </Box>
                              }
                            </Box>
                            <Box sx={{marginLeft:"8px"}}>
                              <Box sx={{display:"flex", alignItems:"center"}}>
                                <Box sx={{fontSize:"14px"}}>{row.seq%2 == 0 ? "참석자 2": "참석자 1"}</Box>
                                {/* {row.sid !== "" ? <Box sx={{fontSize:"14px", fontWeight:600, marginLeft:"8px", color:"red"}}>문장ID : {row.sid}</Box>: ""} */}
                              </Box>
                              <Box><textarea defaultValue={row.stc_con} onChange={(e:any)=> handleChangeStc_con(e.target.value, row.seq)} style={{width:"810px" , minHeight:"30px", fontSize:"12px", fontWeight:600, backgroundColor:((row.qa_flag === "" || row.qa_flag === "None") ? "#fff": (row.qa_flag === "Q" ? "#fbf4dd":"#d5ffd7"))}}  /></Box>
                            </Box>
                          </Box>
                          
                        </Box>
                      </Box>
                    </Box>

                    )
                  ):""
                }
              </Paper>
            </Box>
            
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
            onClick={() => {
              props.setDialogOpen(false);
              // setOpen(false);
            }}
          >
            취소
          </Button>

          
          {data.state === "스크립트검토완료"?
          (
          <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}}
            onClick={() => {
              // nvConScriptUpdate(); 기능막음
              props.setDialogOpen(false);
            }}
          >
            {/* 스크립트검토완료 수정 */}확인
          </Button>
          )
          :
          (data.state === "스크립트제출" ? 
          (<React.Fragment>
            <Button variant="contained" color="error" sx={{fontWeight:700, margin:"8px 16px"}}
              onClick={() => {
                // sampleReject();
                scriptFileRejectPage();
              }}
            >
              스크립트부적합
            </Button>
            <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}}
              onClick={() => {
                scriptFileConfirm();
              }}
              disabled={isButtonDisabled}
            >
              스크립트검토완료
            </Button>
            </React.Fragment>)
          :
          (<React.Fragment>
            <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}}
              onClick={() => {
                scriptFileConfirm();
              }}
              disabled={isButtonDisabled}
            >
              스크립트검토완료
            </Button>
          </React.Fragment>)
          )}
        </DialogActions>
      </Dialog>
      {rejectPageOpen ? <ScriptFileRejectRsnDialog idx={data.idx} mgm_con_pk={data.mgm_con_pk} scriptFileReject={scriptFileReject} /> : ""}
    </Box>
  );
};

export default ScriptDetailDialog;
